import Image from "next/image";
import styles from "./PullMessagePopup.module.scss";
import PullModal from "../pull-modal/PullModal";
import {
  Dispatch,
  MutableRefObject,
  SetStateAction,
  useEffect,
  useRef,
  useState
} from "react";
import { _ } from "../../../services/text-services";
import { Swiper, SwiperSlide } from "swiper/react";
import { PullBoxType, PullEventType, PullMessageResponse } from "../models";
import Link from "next/link";
import { breakpoints } from "./consts";

interface AppPullMessagePopupProps {
  message: PullMessageResponse;
  setMessage: Dispatch<SetStateAction<PullMessageResponse>>;
  onClose: () => void;
  fetchRescueLog: () => void;
}

function AppPullMessagePopup({
  message,
  setMessage,
  onClose,
  fetchRescueLog
}: AppPullMessagePopupProps) {
  const inputEl = useRef<HTMLInputElement>();
  const [localInput, setLocalInput] = useState("");
  const [showInputError, setShowInputError] = useState(false);

  const trySubmitForm = (
    id: number | null,
    event: PullEventType,
    box_input: string,
    is_cancelled: "true" | "false"
  ) => {
    const newData = message;

    newData.logs.box_id = typeof id === "number" ? `${id}` : null;
    newData.logs.event = event;
    newData.logs.box_input = box_input;
    newData.logs.is_cancelled = is_cancelled;

    setMessage(newData);
    fetchRescueLog();
    onClose();
  };

  return (
    <PullModal
      onClose={() => trySubmitForm(null, "DISMISS_BUTTON_CLICKED", "", "true")}
    >
      <div className={styles.mainWrapper}>
        <div className={styles.row1Wrapper}>
          {(message.title || message.body) && (
            <div className={`${styles.col} ${styles.txtWrapper}`}>
              <div
                className={styles.title}
                style={{ color: message.title_color }}
              >
                {_(message?.title)}
              </div>
              <div
                className={styles.description}
                style={{ color: message.body_color }}
              >
                {_(message?.body)}
              </div>
            </div>
          )}

          {message.image && (
            <div className={`${styles.col} ${styles.imgWrapper}`}>
              <div className={styles.img}>
                <Image src={message?.image} alt="" layout="fill" />
              </div>
            </div>
          )}
        </div>

        {/* Just we see button type from server */}
        {message.boxes[0].box_type === PullBoxType.BUTTON && (
          <div className={styles.rowOptionsWrapper}>
            {message.boxes.map((box, index) => {
              return (
                <Link href={box.link || ""} key={index}>
                  <div
                    className={styles.btnWrapper}
                    style={{
                      color: box.text_color,
                      backgroundColor: box.box_color
                    }}
                    onClick={() => {
                      trySubmitForm(
                        box.id,
                        "CALL_TO_ACTION_CLICKED",
                        box.text,
                        "false"
                      );
                    }}
                  >
                    {_(box.text)}
                  </div>
                </Link>
              );
            })}
          </div>
        )}

        {/* Just we see image type from server */}
        {message.boxes[0].box_type === PullBoxType.IMAGE && (
          <div className={styles.rowImagesWrapper}>
            <Swiper
              className={styles.swiperWrapper}
              autoHeight={false}
              slidesPerView={5.5}
              slidesPerGroup={1}
              slidesOffsetAfter={120}
              breakpoints={breakpoints}
            >
              {message.boxes.map((box, index) => (
                <SwiperSlide
                  className={styles.swiperItem}
                  key={`swiper-item-${index}`}
                  virtualIndex={index}
                  onClick={() =>
                    trySubmitForm(
                      box.id,
                      "CALL_TO_ACTION_CLICKED",
                      box.text,
                      "false"
                    )
                  }
                >
                  <div className={styles.imgWrapper}>
                    <Image src={box?.link} alt={box.text} layout="fill" />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}

        {/* Just we see input type from server but we should build the button from it */}
        {message.boxes[0].box_type === PullBoxType.INPUT && (
          <div className={styles.rowInputWrapper}>
            {message.boxes
              .filter(box => box.text)
              .map((box, index) => {
                return (
                  <div key={index} className={styles.wrapper}>
                    <div className={styles.inputWrapper}>
                      <label className={styles.label}>{_(box.text)}</label>
                      <input
                        className={styles.input}
                        onChange={e => setLocalInput(e.target.value)}
                        onKeyUp={e => {
                          if (e.code.includes("Enter")) {
                            if (localInput === "") {
                              return setShowInputError(true);
                            }
                            trySubmitForm(
                              box.id,
                              "CALL_TO_ACTION_CLICKED",
                              _(localInput),
                              "false"
                            );
                          } else {
                            setLocalInput(inputEl.current.value);
                          }
                        }}
                        value={_(localInput)}
                        type="tel"
                        placeholder={_("")}
                        autoComplete="off"
                        ref={inputEl as MutableRefObject<HTMLInputElement>}
                      />

                      {showInputError && (
                        <div
                          className={styles.error}
                        >{`لطفا فیلد را تکمیل کنید.`}</div>
                      )}
                    </div>

                    <button
                      className={styles.btn}
                      style={{
                        color: box.text_color,
                        backgroundColor: box.box_color
                      }}
                      onClick={() => {
                        if (localInput === "") {
                          return setShowInputError(true);
                        } else {
                          trySubmitForm(
                            box.id,
                            "CALL_TO_ACTION_CLICKED",
                            _(localInput),
                            "false"
                          );
                        }
                      }}
                    >
                      {_(box.text)}
                    </button>
                  </div>
                );
              })}
          </div>
        )}
      </div>
    </PullModal>
  );
}

export default AppPullMessagePopup;
